(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    
class StickyAddToCart extends HTMLElement {
  connectedCallback() {
    const stickyButton = this.querySelector('.sticky-atc__button');
    if (!stickyButton) {
      console.warn('Sticky Add to Cart: no se encontró el botón sticky.');
      return;
    }

    stickyButton.addEventListener('click', () => {
      const realButton = document.querySelector('[id^="BuyButtons-ProductSubmitButton-"]');
      if (!realButton) {
        console.warn('Sticky Add to Cart: no se encontró el botón real.');
        return;
      }
      realButton.dispatchEvent(
        new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
      );
    });
  }
}
customElements.define('sticky-add-to-cart', StickyAddToCart);

  } catch(e) { console.error(e); }
})();
})();
